import type { statistics as en } from '@/i18n/locales/en/statistics';
import type { Translation } from '@/i18n/types';

export const statistics: Translation<typeof en> = {
  panelType: {
    series: 'Σειρές',
    sessions: 'Συνεδρίες',
    availability: 'Διαθεσιμότητα',
  },
  status: {
    forbidden: 'Δεν επιτρέπεται να το δείτε αυτό.',
    insufficientData:
      'Δεν υπάρχουν ακόμη αρκετά άτομα με δεδομένα για να εμφανιστεί αυτή η ομάδα χωρίς να ταυτοποιηθεί κανείς.',
    noMetrics: 'Δεν υπάρχουν μετρήσεις σε αυτό το εύρος.',
    noData: 'Δεν υπάρχουν δεδομένα σε αυτό το εύρος.',
    noSessions: 'Δεν υπάρχουν συνεδρίες σε αυτό το εύρος.',
    noAvailability: 'Δεν έχουν καταγραφεί καθόλου δεδομένα.',
    loadFailed: 'Δεν ήταν δυνατή η φόρτωση αυτού του πίνακα: {{message}}',
  },
  target: {
    you: 'Εσείς',
    department: 'Τμήμα {{name}}',
    company: 'Εταιρεία {{name}}',
  },
  table: {
    date: 'Ημερομηνία',
    type: 'Τύπος',
    duration: 'Διάρκεια',
    calories: 'Θερμίδες',
    avgHeartRate: 'Μέσος καρδιακός ρυθμός',
    minutes: '{{count}} λεπτά',
    metric: 'Μέτρηση',
    source: 'Προέλευση',
    first: 'Πρώτο',
    last: 'Τελευταίο',
    days: 'Ημέρες',
  },
  detailLink: 'Προβολή λεπτομερειών',
  range: {
    last7Days: 'Τελευταίες 7 ημέρες',
    last30Days: 'Τελευταίες 30 ημέρες',
    last90Days: 'Τελευταίες 90 ημέρες',
    thisWeek: 'Αυτή την εβδομάδα',
    thisMonth: 'Αυτόν τον μήνα',
    custom: 'Προσαρμοσμένο…',
    from: 'Από',
    to: 'Έως',
  },
};
